<template>
  <DataTable
    :headers="headers"
    :path="path"
    :filter-path="filterPath"
    :actionButtonsName="actionButtonsName"
    :properties="properties"
    :filter="$store.getters.isSafRole">
    <slot slot="before-filters"></slot>
  </DataTable>
</template>

<script>
import DataTable from '../../../common/ui/DataTable'

export default {
  components: {
    DataTable
  },

  data () {
    return {
      path: 'vencimientos/presentations',
      filterPath: 'filters/vencimientos/presentations'
    }
  },

  computed: {
    actionButtonsName () {
      return this.$store.state.permissions.canViewPresentaciones ? 'PresentacionListActionButtons' : ''
    },
    headers () {
      let headers = [
        { text: 'Nombre', align: 'left', value: 'nombre', sortable: false },
        { text: 'Vencimiento', value: 'expiration', sortable: false },
        { text: 'Estado', value: 'status', sortable: false }
      ]
      if (this.$store.state.permissions.canViewPresentaciones) {
        headers.push({ text: 'Acciones', align: 'right', sortable: false })
      }
      if (this.$store.getters.isSafRole) {
        headers.splice(2, 0, { text: 'Club', value: 'club', filterField: true, sortable: false })
      }
      return headers
    },
    properties () {
      let properties = ['nombre', 'fechaVencimiento', 'estadoDisplay']
      if (this.$store.getters.isSafRole) {
        properties.splice(2, 0, 'club.nombre')
      }
      return properties
    }
  }
}
</script>
